import React from 'react';
import { ListGroup } from 'reactstrap';
import { CardTitle, PseudoStates, PageTitle, useFetch } from '@cordata/buffet';
import { sortBy } from 'lodash';
import { useParams } from 'react-router-dom';

import ListGroupItemNotes from '~/components/Note/ListGroupItem';
import MedicalEventsForm from '~/components/MedicalEvent/Form';

const MedicalEventsDetails = () => {
  const params = useParams();
  const [status, data] = useFetch(`medical-events/${params.medical_event_id}`);

  return status === 'success' ? (
    <>
      <PageTitle>{data.attributes.medicalEventLabel}</PageTitle>

      <MedicalEventsForm
        data={data}
      />

      {data.relationships.notes.length ? (
        <div className="mt-5">
          <CardTitle>Previous Notes</CardTitle>

          <ListGroup>
            {sortBy(data.relationships.notes, ['createdDate']).reverse().map(d => (
              <ListGroupItemNotes
                key={d.id}
                data={{ ...d, ...d.attributes }}
                params={params}
              />
              ))}
          </ListGroup>
        </div>
      ) : undefined}
    </>
  ) :
    <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />;
};

export default MedicalEventsDetails;
